// pages/Companies.tsx
import { faPlus, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import CreateCompanyModal from 'components/modals/CreateCompanyModal';
import CompanyTable from 'components/devices/CompanyTable';
import { useState, ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';

const Companies = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div>
      <div className="mb-6">
        <h2
          className="mb-0"
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#374151',
            letterSpacing: '-0.025em'
          }}
        >
          <FontAwesomeIcon icon={faBuilding} className="me-2 text-primary" />
          Companies
        </h2>
        <Row className="g-3 justify-content-end mb-0">
          <Col xs="auto">
            <div className="d-flex gap-2">
              <SearchBox
                placeholder="Search by company name or ID"
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
              <Button
                variant="primary"
                startIcon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => setOpenCreateModal(true)}
                style={{
                  fontSize: '0.875rem',
                  padding: '0.375rem 0.75rem',
                  fontWeight: '500'
                }}
              >
                Add Company
              </Button>
            </div>
          </Col>
        </Row>

        {/* Company Table */}
        <div className="mt-3">
          <CompanyTable searchQuery={searchQuery} />
        </div>

        {/* Create Company Modal */}
        <CreateCompanyModal
          show={openCreateModal}
          handleClose={() => setOpenCreateModal(false)}
        />
      </div>
    </div>
  );
};

export default Companies;
